<template>
  <div>
  <div>
    <div class="topgreen">
	<h2>Time Completed</h2>
        <div id="tick" class="swal2-icon swal2-success swal2-icon-show" style="display: flex;">
          <!-- <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div> -->
      <span class="swal2-success-line-tip" style="background-color: rgb(255, 255, 255);"></span> <span class="swal2-success-line-long"" style="background-color: rgb(255, 255, 255);"></span>
      <div class="swal2-success-ring" style="border-color: rgb(255, 255, 255);"></div>
         <!-- <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div> -->
      <!-- <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div> -->
    </div>

    </div>
    <div class="whiteback">
      <div class="start">
        <div class="circleicon"></div>
          <strong>Start:</strong><br>{{results.startDisplayTime}}
        </div>
        <div class="end">
          <div class="circleicon"></div>
          <strong>Ended:</strong><br>{{results.endDisplayTime}}
        </div>
        <div class="duration">
          <strong>{{results.duration}}</strong>
        </div>
        <div class="settings">
          <div class="break">Break:{{results.breaktime}}</div>
          ...
          <a @click.prevent="deleteTimeEntry(results.start,results.end)">Delete</a>
        </div>
        <div class="btn btn-primary" @click="showhistory = true;" v-show="!showhistory">Show History</div>
        
      <div>
        <router-link to="/tapon">Start Timer again</router-link><br>
      </div>
      <br><br>
      <div class="btn btn-primary">Upload to Xero</div>
      
      <div v-if="history.length" v-show="showhistory">
        <div v-for="h in history"  class="sheet" v-bind:key="h.start">
          <div v-if="h" :class="'status'+h.status">
            <div>
              <strong>Start:</strong><br>{{h.startDisplayTime}}
            </div>
            <div>
              <strong>Ended:</strong><br>{{h.endDisplayTime}}
            </div>
            <div class="duration"><strong>{{h.duration}}</strong>
            </div>
            <div class="settings">
              ...
              <a @click.prevent="deleteTimeEntry(h.start,h.end)">Delete</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- {{history|json}} -->
      <!-- {{howlong}} -->
      <br><br>
  </div>
</template>

<script>

import envConfig from './env_config.js'
import * as easing from 'eases/bounce-in'
import moment from 'moment';
import axios from 'axios'
const http = axios.create({
  withCredentials: true,
  crossdomain: true
})
export default {
  name: 'TapOff',
  props: {
  },
  data () {
    return {
      howlong: 0,
      history: [],
      results: {},
      showhistory:false
    }
  },
  methods: {
    getTimerHistory() {
      var history = localStorage.getItem('timer-history');
      if (history)
        return JSON.parse(history);
      return [];
    },
    addTimerHistory(start, end,duration) {
      var history = this.getTimerHistory();
      
      history.push({
        "start": start,
        "startDisplayTime":  moment.unix(start).format("h:mm a"),
        "startDisplayDate":  moment.unix(start).format("YYYY-MM-DD"),
        "end": end,
        "endDisplayTime":  moment.unix(end).format("h:mm a"),
        "endDisplayDate": moment.unix(end).format("YYYY-MM-DD"),
        "breaktime":"30mins",
        status: 'new',
        duration:duration
      });
      localStorage.setItem('timer-history', JSON.stringify(history));

    },
    deleteTimeEntry(start, end) {
      var history = this.getTimerHistory();
      var keepList = [];
      for(var i in history){
        var h = history[i];
        if (h && h.start == start && h.end == end) {
          //don't keep
        } else {
          keepList.push(history[i]);
        }
      }
      
      localStorage.setItem('timer-history', JSON.stringify(keepList));
      this.history = this.getTimerHistory();
    },
    calcTimer: function (start,end) {
      var duration = moment.duration(end.diff(start));
      return moment.utc(duration.as('milliseconds')).format('HH:mm:ss');
    }
  },
  mounted() {
  },
  created: function () {
    this.history = this.getTimerHistory();
    if (localStorage.getItem('timer-started')) {

      localStorage.setItem('timer-ended', moment().format('X'));
      var startRaw = localStorage.getItem('timer-started');
      var start = moment.unix(startRaw);
      var endRaw = localStorage.getItem('timer-ended');
      var end = moment.unix(endRaw);
      var duration = this.calcTimer(start, end);

      this.addTimerHistory(startRaw, endRaw, duration);
      localStorage.removeItem('timer-started');
      localStorage.removeItem('timer-ended');
    }
    this.history = this.getTimerHistory();
    this.results = this.history[this.history.length - 1];
  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style scoped>
  .sheet {
    background: white;
    margin:10px;
    padding:10px 20px;
    border-radius: 5px;;
    /* box-shadow: ; */
  }
  .sheet div {
    display: inline-block;
    padding:10px;
  }
  .status {

  }
  .topgreen {
    /* background:green; */
    height:40vh;
  }
  .topgreen h2{
    margin-top:20px;
    color:white;
  }
  .whiteback {
    background:white;
    min-height:60vh;
    padding-top:15px;
  }
  .whiteback .start {
    display: inline-block;
    padding:10px;
    text-align: center;
  }
  .whiteback .end {
    display: inline-block;
    padding:10px;
    text-align: center;
  }
  .whiteback .duration {
    display: inline-block;
    padding:10px;
    text-align: center;
  }
  .circleicon {
    width:20px;
    background:lightpink;
    height:20px;
    margin:0 auto;
    border-radius: 50%;
  }
  #tick {
    transform: scale(1.5);
    opacity: 0.6;
    margin-top:50px;
  }
</style>





